import { useTheme } from '@mui/material/styles';

type LayoutProps = {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  fullWidth?: boolean;
};

const Layout: React.FC<LayoutProps> = ({
  header,
  footer,
  children,
  fullWidth = false,
}) => {
  const theme = useTheme();

  const containerStyles: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.grey[50],
    minHeight: '100%',
  };

  const contentContainerStyles: React.CSSProperties = fullWidth
    ? { marginBottom: '2rem' }
    : {
        maxWidth: '1312px',
        margin: '0 auto',
        padding: '0 16px',
        marginBottom: '2rem',
      };

  return (
    <div className="app-container" style={containerStyles}>
      {/* Content of the page. Will include the header */}
      <div>
        {header}
        <div style={contentContainerStyles}>{children}</div>
      </div>

      {/* Footer pass in as a property, no default */}
      <footer>{footer}</footer>
    </div>
  );
};

export default Layout;
